import React from 'react'
import { v4 as uuid } from 'uuid';
import Helmet from 'react-helmet';


import { partnerMerchants } from './constants';
import '../../../public/css/media/_us-shopping.scss';
import { netcoreScript } from '../../utils/utils';
import { history } from '../../store';

const metadata = "Enjoy fast and affordable shipping from the US to your doorstep in the Philippines with ShippingCart. Visit this page to find out more.";
const title = "Shop in the US and Ship to the Philippines | ShippingCart";

const tableBodyBorderLeftRight ={
  borderRight: '1px solid #E2E2E2',
  borderLeft: '1px solid #E2E2E2',
  padding: '10px 20px'
}

const tableHeaderStyle ={
  border: '1px solid #E2E2E2',
  padding: '20px',
  fontWeight: 600
}

const createReactClass = require('create-react-class');

const USShopping = createReactClass({
  componentDidMount() {
    document.getElementById('chck1').checked = true
    // <!-- NetCore Script -->
    const accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '' ;
    window.smartech && netcoreScript(accountNumber);
    // <!-- NetCore Script -->    
  },

  renderMerchantLogos(category)  {
    return (
        partnerMerchants[category].map(({logo, link, alt}) => (
          <div key={uuid()} className="logo-store">
            <a href={link} target="_blank" rel="noopener noreferrer">
              <img src={logo} alt={alt} />
            </a>
          </div>
        ))
    )
  },
  // const renderBanners = () => (
  //   banners.map(({img, alt, customClass}) => (
  //     <div key={uuid()} className={`content ${customClass}`}>
  //       <img src={img} alt={alt} />
  //     </div>
  //   ))
  // )
  render () {
    return (
      <div>
        <Helmet>
            <meta name="description" content={metadata} data-react-helmet="true" />
            <title>{title}</title>
          </Helmet>
        <section style={{background: 'transparent url("https://cdn.shippingcart.com/assets/wave-bg@2x-20230509032549.jpg")', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'bottom', backgroundColor: '#FFF'}}>
          <div className="container row1-cols2-layout">
            <div className="content" style={{marginTop: '30px'}}>
              {/* <h1 className="headers">Buy from the US and Ship to the Philippines</h1> */}
              
              <div className="wrapper-content">
                <div className="cols cols-1">
                    <img src="https://cdn.shippingcart.com/assets/oregon-update-main-banner-1@2x-20230509023152.png" alt="shop-in-us" height="360" width="423" />
                </div>
                <div className="cols cols-2">
                  <p style={{fontSize: '24px', fontWeight: 600, color: '#333333'}}>
                    Buy from the US, and Ship to the Philippines
                  </p>
                    <p>
                        With ShippingCart, buying from US sites like Amazon, Carter’s and Disney, and shipping to the Philippines is more affordable as we offer competitive prices with no hidden charges. We also offer free storage for up to 30 days.
                    </p>
                    <p>
                        <span style={{fontWeight: 600}}> And with our Oregon warehouse, no more sales tax will be added to your online purchases!</span> Just input the free US Oregon delivery address that is displayed on your ShippingCart account when you checkout from eStores.
                    </p>
                    {this.props.isAuthenticated || localStorage.jwtToken ? null :
                    <button
                      onClick={() => history.push('/signup')} 
                      style={{backgroundColor: '#AA0E0E', border: '1px solid #AA0E0E', borderRadius: '23px', width: '195px', height: '46px', fontSize: '16px', fontWeight: 600, color: '#FFF'}}
                    >
                      SIGN UP NOW
                    </button>
                    }
                </div>
            </div>
            </div>
          </div>
        </section>
        <section className="odd">
          <div className='container'>
            <div style={{fontSize: '24px', fontWeight: 600, color: '#333333', margin: '20px 0px'}}>Here are sample savings when you use an Oregon delivery address upon checking out</div>
            <div className="us-item-list">
              <table  style={{backgroundColor: '#fff', borderRadius: '10px', width: '100%', fontSize: '16px'}}>
                <thead style={{border: '1px solid #E2E2E2'}}>
                  <tr>
                      <th className='center' style={tableHeaderStyle}>Item</th>
                      <th className='center' style={tableHeaderStyle}>Using a California Address</th>
                      <th className='center' style={tableHeaderStyle}>Using a no-sales tax Oregon address</th>
                      <th className='center' style={tableHeaderStyle}>Savings</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                      <td style={tableBodyBorderLeftRight}>Apple iPad Mini</td>
                      <td className='center' style={tableBodyBorderLeftRight}>$543.49</td>
                      <td className='center' style={tableBodyBorderLeftRight}>$499.99</td>
                      <td className='center' style={tableBodyBorderLeftRight}>$43.50</td>
                  </tr>
                  <tr>
                      <td style={tableBodyBorderLeftRight}>Air Jordan 1</td>
                      <td className='center' style={tableBodyBorderLeftRight}>$152.15</td>
                      <td className='center' style={tableBodyBorderLeftRight}>$138.00</td>
                      <td className='center' style={tableBodyBorderLeftRight}>$14.15</td>
                  </tr>
                  <tr>
                      <td style={tableBodyBorderLeftRight}>Solo Leveling Comic Box Set, Vol 1 - 5</td>
                      <td className='center' style={tableBodyBorderLeftRight}>$95.63</td>
                      <td className='center' style={tableBodyBorderLeftRight}>$90.00</td>
                      <td className='center' style={tableBodyBorderLeftRight}>$5.63</td>
                  </tr>
                  <tr>
                      <td style={tableBodyBorderLeftRight}>Harry Potter 18-inch Funko Pop Vinyl</td>
                      <td className='center' style={tableBodyBorderLeftRight}>$106.24</td>
                      <td className='center' style={tableBodyBorderLeftRight}>$99.99</td>
                      <td className='center' style={tableBodyBorderLeftRight}>$6.25</td>
                  </tr>
                  <tr>
                      <td style={tableBodyBorderLeftRight}>Kyrie Irving Autographed 16x20</td>
                      <td className='center' style={tableBodyBorderLeftRight}>$318.74</td>
                      <td className='center' style={tableBodyBorderLeftRight}>$299.99</td>
                      <td className='center' style={tableBodyBorderLeftRight}>$18.75</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
        <section style={{backgroundColor: '#FFF'}}>
          <div className="container logos">
            <div className="content">
              <h1 className="header">Top Picks</h1>
              <div className="logo-stores">
                { this.renderMerchantLogos('topPicks') }
              </div>
            </div>
          </div>
        </section>
        <section className="odd">
          <div className="container logos">
            <div className="content">
              <h1 className="header">Fashion &amp; Beauty</h1>
              <div className="logo-stores">
                { this.renderMerchantLogos('fashionBeauty') }
              </div> 
            </div>
          </div>
        </section>
        <section style={{backgroundColor: '#FFF'}}>
          <div className="container logos">
            <div className="content">
              <h1 className="header">Lifestyle &amp; Tech</h1>
              <div className="logo-stores">
                { this.renderMerchantLogos('lifestlyleTech') }
              </div>
            </div>
          </div>
        </section>
        <section className="odd">
          <div className="container logos">
            <div className="content">
              <h1 className="header">Toys, Kids &amp; Babies</h1>
              <div className="logo-stores">
                { this.renderMerchantLogos('toysKids') }
              </div>
            </div>
          </div>
        </section>
        <section style={{backgroundColor: '#FFF'}}>
          <div className="container logos">
            <div className="content">
              <h1 className="header">Sports, Hobby &amp; Health</h1>
              <div className="logo-stores">
                { this.renderMerchantLogos('sportsHobbyHealth') }
              </div>
            </div>
          </div>
        </section>
        <section className="odd" hidden>
          
          <div className="container hero seo-element">
            <div className="content seo-element">
              <div className="seo-content">
                <h3 className="header" style={{color: '#707070', fontWeight: '600', paddingBottom: '40px'}}>
          FREQUENTLY ASKED QUESTIONS</h3>
                <div className="row">
                    <div className="col">
                      <div className="tabs">
                        <div className="tab">
                          <input type="checkbox" id="chck1" onChange={(e)=> { console.log(e.target.checked, 'TEST') }}/>
                          <label className="tab-label" htmlFor="chck1">How to buy from the US and ship to the Philippines?</label>
                          <div className="tab-content">
    
                            <p>When you become a member today, we'll give you a free US address to use when you shop from online stores. We will then handle all the shipping from our hub to your doorstep.</p>
                            <p>
                            Shopping from online stores like Amazon and shipping to the Philippines is this quick and easy:
                            </p>
                            <ul className="listStyle">
                              <li>Sign up for an account today and get a free ShippingCart US address.</li>
                              <li>Shop from your favorite online retailers.</li>
                              <li>
                              At checkout, use your free ShippingCart US address.
                              </li>
                            </ul>
                            <p>
                            Your purchase will be delivered to our address.  We will consolidate all your orders, and then ship to the Philippines – straight to you! 
                            </p>
                            <p>
                            Plan on buying from eBay and shipping to the Philippines?
                            </p>
                            <p>
                            Don’t stop there! You can also shop for shoes, clothes, makeup, and many other items at other US stores like:
                            </p>
                            <ul className="listStyle">
                              <li>Amazon</li>
                              <li>Walmart.com</li>
                              <li>Asos</li>
                              <li>Nordstrom</li>
                              <li>eBags</li>
                              <li>Drugstore.com</li>
                              <li>Walgreens</li>
                              <li>GAP</li>
                              <li>Neiman Marcus</li>
                              <li>Victoria’s Secret</li>
                              <li>Bath & Body Works</li>
                              <li>Rue La La</li>
                              <li>Colourpop</li>
                              <li>bliss</li>
                              <li>Saks Fifth Avenue</li>
                            </ul>
                            <p>When your orders arrive at our hub, our expert packers can combine them in a single shipment, helping you save on your shipping fee to the Philippines.</p>
                          </div>
                        </div>
                        <div className="tab">
                          <input type="checkbox" id="chck2" />
                          <label className="tab-label" htmlFor="chck2">How long does it take to ship to Philippines?</label>
                          <div className="tab-content">
                            <p>ShippingCart always looks for fast and affordable ways for our customers to shop in the US and ship to the Philippines. Depending on your chosen shipment method, your items can arrive in the PH in just 14 days via air cargo. If you prefer a more budget-friendly option, we offer shipment via sea cargo that takes up to 45 days.</p>
                          </div>
                        </div>
                        <div className="tab">
                          <input type="checkbox" id="chck3" />
                          <label className="tab-label" htmlFor="chck3">How does package consolidation work?</label>
                          <div className="tab-content">
                            <p>When you’re ready to ship your items, you can ship them out individually or wait for your other items to arrive so you can consolidate them all into a single shipment. </p>
                            <p>
                            ShippingCart’s free consolidation service helps you save on handling fees, reducing your overall shipping costs. However, please note that even if you consolidate your packages under one transaction, handling fees are charged separately for air and sea cargo. It’s best to choose a single shipping method for all your packages.
                            </p>
                          </div>
                        </div>
                        <div className="tab">
                          <input type="checkbox" id="chck4" />
                          <label className="tab-label" htmlFor="chck4">How much does it cost to ship items from the US to the Philippines?</label>
                          <div className="tab-content">
                            <p>Find out how low our rates are with our cost calculator. Get your shipment fee estimate based on the information you provide. It’s quick, free, and easy!</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      )
  },
})

export default USShopping;


/** WEBPACK FOOTER **
 ** ./src/components/USShopping/USShopping.js
 **/